/* eslint-disable react-hooks/rules-of-hooks */
import React from 'react';
import Tourneys from '@screens/tourneys/tourneys';
import Players from '@screens/players/players';
import Seasons from '@screens/season/seasons';
import { useGame } from '@domain/game.selection/game.selection.hook';
import { GameType } from '@domain/game.selection/types/game.type';
import JackpotWinners from '@screens/jackpot.winners/jackpot.winners';
import Kicks from '@screens/kicks/kicks';

export interface MenuOption {
  id: string;
  title: string;
  description?: string;
  url: string;
  routePath?: string;
  icon: string;
  routeComponent: React.ComponentType;
  condition?(): boolean;
}

export function useMenuOptions(): MenuOption[] {
  // eslint-disable-next-line no-use-before-define
  return menuOptionsData.filter((o) => !o.condition || o.condition());
}

export function gameTypeFilter(gameType: GameType) {
  const game = useGame();
  return game.type === gameType;
}

const menuOptionsData: MenuOption[] = [
  { id: 'players', title: 'Players', url: '/players', icon: 'people', routeComponent: Players },
  { id: 'tourneys', title: 'Tourneys', url: '/tourneys', icon: 'military_tech', routeComponent: Tourneys },
  { id: 'seasons', title: 'Seasons', url: '/seasons', icon: 'date_range', routeComponent: Seasons, condition: () => gameTypeFilter(GameType.Rex) },
  { id: 'jackpot-winners', title: 'Jackpot Winners', url: '/jackpot-winners', icon: 'emoji_events', routeComponent: JackpotWinners },
  { id: 'kicks', title: 'Kicks', url: '/kicks', icon: 'comments_disabled', routeComponent: Kicks, condition: () => gameTypeFilter(GameType.Praia) },
];
